var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"textData"},[_c('b-col',{class:_vm.labelGridClass,attrs:{"sm":"3"}},[_c('label',[_vm._v(_vm._s(_vm.label))])]),_c('b-col',{staticClass:"pl-20 textWrap",attrs:{"sm":_vm.sm}},[_c('span',[_vm._v(_vm._s(_vm.data))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }